import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css } from 'lit'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const hostDisplayContents = css`
  :host {
    display: contents;
  }
`

export const hostBlockStyles = css`
  :host {
    display: block;
    min-width: 0;
    overflow-x: hidden;
  }
`

export const overviewStyles = css`
  csc-account-header {
    margin-bottom: ${csSpacing.spacing08};
  }

  .mobile-action-bar {
    display: flex;
    margin-bottom: ${csSpacing.spacing08};
  }

  cse-list cse-selectable {
    width: 100%;
    text-align: left;

    .status {
      text-align: left;
    }
  }

  .columns {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: ${csSpacing.spacing05};
    align-items: start;
    text-align: left;
  }
`

export const formStyles = css`
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: "form";
    
    @media(min-width: ${SCREENS.medium}) {
      grid-template-columns: 1fr 1fr;
      grid-template-areas: "form .";
    }
    
    .form {
      grid-area: form;
    }
  }
`

export const productsStyles = css`
  cse-list-item {
    .grid-container {
      display: grid;
      grid-template-areas:
            "product-preview product-preview"
            "quantity subtotal"
            "divider divider";
      grid-template-columns: 1fr auto;
      grid-column-gap: ${csSpacing.spacing06};
      grid-row-gap: ${csSpacing.spacing06};
      width: 100%;

      &.quantity-changeable {
        grid-template-areas:
              "product-preview product-preview product-preview"
              "quantity button subtotal"
              "divider divider divider";
        grid-template-columns: 1fr auto auto;

        csc-quotation-quantity {
          width: 80px;
        }
      }

      &.selectable {
        grid-template-areas:
              "selector product-preview product-preview"
              "selector quantity subtotal"
              "divider divider divider";
        grid-template-columns: auto 1fr auto;
        cursor: pointer;

        &.quantity-changeable {
          grid-template-areas:
                "selector product-preview product-preview product-preview"
                "selector quantity button subtotal"
                "divider divider divider divider";
          grid-template-columns: auto 1fr auto auto;
        }
      }

      cse-radio-button {
        grid-area: selector;
        align-self: center;
      }

      csc-quotation-product-preview {
        grid-area: product-preview;
      }

      .quantity {
        grid-area: quantity;
        align-self: center;
        justify-self: end;
      }

      cse-icon-button {
        grid-area: button;
        align-self: center;

        --cse-icon-button-secondary-color: var(--csc-quotation-lines-delete-button-color, ${csColorFunctional.error});
        --cse-icon-button-secondary-color-hover: var(--csc-quotation-lines-delete-button-color-hover, ${csColorFunctional.errorHover});
      }

      cse-caption-description {
        grid-area: subtotal;
        align-self: center;
        justify-self: end;
      }

      cse-divider {
        grid-area: divider;
      }

      &.hide-subtotal {
        .quantity {
          grid-column-end: -1;
        }
      }
    }
  }

  @media(min-width: ${SCREENS.small}) {
    cse-list-item {
      .grid-container {
        grid-template-areas:
              "product-preview quantity subtotal"
              "divider divider divider";
        grid-template-columns: 1fr 80px 100px;

        &.quantity-changeable {
          grid-template-areas:
                "product-preview quantity button subtotal"
                "divider divider divider divider";
          grid-template-columns: 1fr 80px 25px 100px;
          grid-column-gap: ${csSpacing.spacing06};
        }

        &.selectable {
          grid-template-areas:
                "selector product-preview quantity subtotal"
                "divider divider divider divider";
          grid-template-columns: auto 1fr 80px 100px;

          &.quantity-changeable {
            grid-template-areas:
                  "selector product-preview quantity button subtotal"
                  "divider divider divider divider divider";
            grid-template-columns: auto 1fr 80px 25px 100px;
          }
        }
      }
    }
  }
`

export const requestInformationStyles = css`
  [class^='columns-'] {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: ${csSpacing.spacing06};

    @media(min-width: ${SCREENS.small}) {
      grid-template-columns: repeat(3, 1fr);

      &.columns-1 {
        grid-template-columns: 1fr;
      }

      &.columns-2 {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
`

export const totalPriceStyles = css`
  .total {
    display: grid;
    grid-template-areas: ". text price";
    grid-template-columns: 1fr auto auto;
    column-gap: ${csSpacing.spacing06};

    .text {
      display: grid;
      grid-template-columns: auto;
      grid-area: text;
      row-gap: ${csSpacing.spacing01};
    }

    .total-price {
      grid-area: price;
      justify-self: end;
    }
  }
`

export const requestButtonStyles = css`
  :host {
    display: block;
    width: 100%;
  }

  cse-alert {
    display: block;
    width: 100%;
    margin-bottom: ${csSpacing.spacing05};
  }

  .actions {
    display: flex;
    justify-content: flex-end;
  }
`

export const modalStyles = css`
  cse-label {
    width: 100%;
  }

  cse-textarea {
    width: 100%;
  }
`
